package dev.krno.data

data class Slot(
    val time: String,
    val title: String,
    val who: String,
    val tag: String,
    val break_: Boolean = false,
    val party: Boolean = false,
)

data class Speaker(
    val name: String,
    val role: String,
    val talk: String,
    val description: String = "",
    val photo: String = "",
)

data class Partner(
    val name: String,
    val role: String,
    val url: String = "",
)

object EventData {
    const val EVENT_DATE = "24. 11. 2026"
    const val EVENT_DATE_TIME = "24. 11. 2026 · 17:30"
    const val VENUE = "STRV Brno Office"
    const val REGISTER_URL = "https://luma.com/event/evt-IF7UuhE3AwM8AcX"
    const val LUMA_EVENT_ID = "evt-IF7UuhE3AwM8AcX"
    const val CONTACT_EMAIL = "hello@brnko.cz"
    const val VENUE_LAT = 49.1904162
    const val VENUE_LON = 16.6167968
    const val VENUE_MAPS_URL = "https://maps.app.goo.gl/M4HMsg5wm5wiX3Mv6"

    val program: List<Slot> = listOf(
        Slot("17:30", "Doors open", "Name tags, first beer, snacks", "Beer"),
        Slot("18:00", "Welcome & intro", "BrnKo organisers", "Intro"),
        Slot(
            "18:10",
            "Async Is the New goto: What Structured Concurrency Is Really About",
            "Wout Werkman · JetBrains",
            "Talk",
        ),
        Slot(
            "18:50",
            "Your offline-first app is not a sync queue",
            "Michal Jeníček · STRV",
            "Talk",
        ),
        Slot("19:30", "Break", "Stretch, refill, talk to the speakers", "Break", break_ = true),
        Slot(
            "19:50",
            "Stop Being Insecure: Achieving Bank-Level Security",
            "Ondra Kalman · Futured",
            "Talk",
        ),
        Slot(
            "20:10",
            "Kotlin's 15th Birthday Party",
            "Cake, a toast and your wishes for the next 15 years",
            "Party",
            party = true,
        ),
        Slot(
            "20:30",
            "Networking",
            "Until we run out of beer, or 23:00",
            "Open",
        ),
    )

    val speakers: List<Speaker> = listOf(
        Speaker(
            name = "Wout Werkman",
            role = "Software Engineer · JetBrains",
            talk = "Async Is the New goto: What Structured Concurrency Is Really About",
            description = "Structured concurrency is widely known in the Kotlin community, but its main goal is often missed. We'll build our understanding from first principles: what asynchronous functions actually are — spoiler: suspend fun != asynchronous function — why we want to get rid of them, and how structured concurrency makes that possible.\n\nUsing a custom-built visual debugger, we'll watch coroutines execute and build the necessary mental model step by step.\n\nNo prior concurrency knowledge is expected.",
            photo = "assets/wout.jpg",
        ),
        Speaker(
            name = "Michal Jeníček",
            role = "Senior Mobile Engineer · STRV",
            talk = "Your offline-first app is not a sync queue",
            description = "Offline-first apps usually reach for a sync queue: writes get queued, replayed when connectivity returns, and conflicts get resolved by whoever wrote last. It works — until it doesn't.\n\nThis talk shows an event-sourced Kotlin Multiplatform architecture that records immutable events instead of queuing writes. A separate engine derives state from those events, and version snapshots handle conflicts automatically.\n\nThe same Kotlin module runs on both client and backend (compiled to JavaScript), so behaviour is identical online or offline — with no lost writes or silent data divergence.",
            photo = "assets/michal.jpg",
        ),
        Speaker(
            name = "Ondra Kalman",
            role = "Android Developer · Futured",
            talk = "Stop Being Insecure: Achieving Bank-Level Security",
            photo = "assets/ondra.jpg",
        ),
    )

    // Not a speaker — feeds the same detail popup when the 20:10 party slot is clicked.
    val birthdayParty = Speaker(
        name = "Kotlin turns 15",
        role = "Birthday party · 20:10",
        talk = "Kotlin's 15th Birthday Party",
        description = "This year Kotlin turns 15! To celebrate, JetBrains invited Kotlin communities around the world to join the party – and we couldn't say no to that. They sent us cake and a little surprise for everyone.\n\nFifteen years of writing less and doing more: from the first announcement in 2011 through Kotlin 1.0, coroutines, Multiplatform and the K2 compiler. Brno joins dozens of Kotlin birthday meetups happening around the world this year.\n\nGrab a slice, raise a toast, and bring your birthday wish or your boldest prediction for Kotlin's next 15 years.",
        photo = "assets/kodee-poster.webp?v=2",
    )

    val partners: List<Partner> = listOf(
        Partner("STRV", "Partner · venue", "https://www.strv.com/"),
        Partner("Futured", "Partner", "https://www.futured.app/"),
        Partner("JetBrains", "Sponsor", "https://www.jetbrains.com/"),
    )
}
